import { render, staticRenderFns } from "./WorkflowEdges.vue?vue&type=template&id=7d4c5d38&scoped=true&"
import script from "./WorkflowEdges.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkflowEdges.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WorkflowEdges.vue?vue&type=style&index=0&id=7d4c5d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c5d38",
  null
  
)

export default component.exports